import { createWrapper } from 'src/careflow/ph-core/fhir-client/fhir-react/base';

export const ActivityDefinitionWrapper = createWrapper(
  'ActivityDefinition',
  (activityDefinition) => ({})
);

export type WrappedActivityDefinition = ReturnType<typeof ActivityDefinitionWrapper>;
